import { hasOneOf } from '@/libs/tools';

/**
 * 权限控制指令
 */
export default {
  inserted: function (el, binding) {
    const access = sessionStorage.getItem('access');
    const codes = binding.value
      .toString()
      .split(',')
      .map((x) => x);
    if (!hasOneOf(codes, access)) {
      el.style.display = 'none';
    }
  },
};
